import styled, { CSSProperties } from 'styled-components';

import { BodilColor } from '~src/branding';

export const Divider = styled.div<{ color?: string; thickness?: CSSProperties['height'] }>(
  ({ color = BodilColor.greyscale[40], thickness = '1px' }) => ({
    borderBottom: `${thickness} solid ${color}`,
    width: '100%',
    height: '0px',
    margin: '8px 0',
  })
);
